import { render, staticRenderFns } from "./SendPurchaseOrderToVendor.vue?vue&type=template&id=bd2fa570&scoped=true&"
import script from "./SendPurchaseOrderToVendor.vue?vue&type=script&lang=js&"
export * from "./SendPurchaseOrderToVendor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd2fa570",
  null
  
)

export default component.exports